import { ReactNode } from "react";

import { captureException, captureMessage } from "@sentry/nextjs";

const removeSpaceFromString = (string: string): string =>
  string?.replace(/\s+/g, "-");

const replaceCharactersWithAccentWithNormalCharacters = (
  stringWithAccents: string,
) => stringWithAccents?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");

export const removeSpacesAndAccentsFromString = (
  dryString: string | ReactNode,
): string => {
  let result = "";
  if (typeof dryString !== "string") return result;

  try {
    const dryStringInLowerCase = `admin-console-${dryString?.toLowerCase()}`;
    const stringWithoutSpaces = removeSpaceFromString(dryStringInLowerCase);
    const cleanString =
      replaceCharactersWithAccentWithNormalCharacters(stringWithoutSpaces);

    result = cleanString;
  } catch (error) {
    console.log("Erro (removeSpacesAndAccentsFromString): ", error);
    captureException(error);
    captureMessage("Erro (removeSpacesAndAccentsFromString)");
  }

  return result;
};
